import type { MessageKey } from './messages';
import type { TranslateParams } from './translate';

type TranslateFn = (key: MessageKey, params?: TranslateParams) => string;

const LOGIN_TYPE_KEYS: Record<string, MessageKey> = {
  'business client': 'login.option.businessClient',
  'private client': 'login.option.privateClient',
  'business worker': 'login.option.businessWorker',
  'asset owner': 'login.option.assetOwner',
  'business asset owner': 'login.option.businessAssetOwner',
  'private asset owner': 'login.option.privateAssetOwner',
};

const USER_TYPE_KEYS: Record<string, MessageKey> = {
  'business client': 'userType.businessClient',
  'private client': 'userType.privateClient',
  'business worker': 'userType.businessWorker',
  'asset owner': 'userType.assetOwner',
  'business asset owner': 'userType.businessAssetOwner',
  'private asset owner': 'userType.privateAssetOwner',
};

export function translateLoginOption(raw: string, t: TranslateFn): string {
  const key = LOGIN_TYPE_KEYS[raw.trim().toLowerCase()];
  return key ? t(key) : raw;
}

export function translateUserTypeLabel(raw: string, t: TranslateFn): string {
  const key = USER_TYPE_KEYS[raw.trim().toLowerCase()];
  return key ? t(key) : raw;
}
